import { useMemo } from 'react';

import { SelectField, SelectFieldProps } from '@/components/molecules/SelectField';
import { useGetMasterList } from '@/hooks/useGetMasterList';
import { findMasterDataGroup } from '@/utils';

type Props<IForm extends object> = SelectFieldProps<
  IForm,
  {
    id: string;
    value: string;
  }
>;

export const SelectAcademic = <IForm extends object>(props: Props<IForm>) => {
  const { data, isLoading, isFetching } = useGetMasterList();
  const academicList = useMemo(() => findMasterDataGroup(data, 'TRINH-DO-HOC-VAN', '3'), [data]);

  const selectProps = {
    autoFocus: props.autoFocus,
    className: props.className,
    classNameInputHint: props.classNameInputHint,
    clearable: props.clearable,
    control: props.control,
    disabled: props.disabled,
    emptyOptionText: props.emptyOptionText,
    emptySearchResultText: props.emptySearchResultText,
    errorClass: props.errorClass,
    getOptionLabel: (option: { id: string; value: string }) => option.value,
    groupClass: props.groupClass,
    hint: props.hint,
    hintClass: props.hintClass,
    id: props.id,
    isLoading: props.isLoading || isLoading || isFetching,
    label: props.label,
    labelClass: props.labelClass,
    name: props.name,
    options: academicList?.data || [],
    placeholder: props.placeholder,
    required: props.required,
    rtl: props.rtl,
    searchable: props.searchable,
    solid: props.solid,
  };

  return (
    <SelectField
      {...selectProps}
      getOptionValue={props.getOptionValue}
      onChange={props.onChange as any}
      value={props.value as any}
      multiple={props.multiple}
    />
  );
};
